/** Shell / More badge counts — plan/22 · plan/32 · plan/50. */

export function navBadgeLabel(label: string, count: number): string {
  if (!Number.isFinite(count) || count <= 0) return label;
  const n = count > 99 ? "99+" : String(Math.floor(count));
  return `${label} (${n})`;
}

/**
 * Shell notif badge = Messages unread + open Act (Needs me), with approval dedup.
 *
 * - Inbox contribution omits `approval_pending` unread when Approvals are shown
 *   (those ask are counted once via `approvalsPending`).
 * - `actOpenCount` = assigned docs + queue **doc counts** (not one per axis kind).
 * - Does **not** include Inbox rows in actOpenCount — Messages stay bell/peeks.
 */
export function shellNotifBadgeCount(input: {
  inboxUnread: number;
  /** Unread notifications with type approval_pending (subset of inboxUnread). */
  inboxApprovalUnread: number;
  approvalsPending: number;
  /** Assigned SO/PO + to-collect/deliver/pay/receive doc counts (>0 only). */
  actOpenCount: number;
  showInbox: boolean;
  showApprovals: boolean;
  /** When false, omit Act (e.g. More after bell owns Needs me). Default true. */
  includeAct?: boolean;
}): number {
  const inboxUnread = Math.max(0, input.inboxUnread);
  const approvalUnread = Math.min(
    inboxUnread,
    Math.max(0, input.inboxApprovalUnread),
  );
  const inboxOther = Math.max(0, inboxUnread - approvalUnread);

  let n = 0;
  if (input.showInbox) {
    n += inboxOther;
    if (!input.showApprovals) n += approvalUnread;
  }
  if (input.showApprovals) {
    n += Math.max(0, input.approvalsPending);
  }
  if (input.includeAct !== false) {
    n += Math.max(0, input.actOpenCount);
  }
  return n;
}

/** @deprecated Use shellNotifBadgeCount — kept for call sites mid-migration. */
export function moreMenuBadgeCount(input: {
  inboxUnread: number;
  approvalsPending: number;
  showInbox: boolean;
  showApprovals: boolean;
  inboxApprovalUnread?: number;
  actOpenCount?: number;
}): number {
  return shellNotifBadgeCount({
    inboxUnread: input.inboxUnread,
    inboxApprovalUnread: input.inboxApprovalUnread ?? 0,
    approvalsPending: input.approvalsPending,
    actOpenCount: input.actOpenCount ?? 0,
    showInbox: input.showInbox,
    showApprovals: input.showApprovals,
  });
}

/** Sum queue/assigned doc counts for the Act badge bucket. */
export function actOpenDocCount(input: {
  assignedSo: number;
  assignedPo: number;
  toCollect: number;
  toDeliver: number;
  toPay: number;
  toReceive: number;
}): number {
  return (
    Math.max(0, input.assignedSo) +
    Math.max(0, input.assignedPo) +
    Math.max(0, input.toCollect) +
    Math.max(0, input.toDeliver) +
    Math.max(0, input.toPay) +
    Math.max(0, input.toReceive)
  );
}
